module.exports = __webpack_public_path__ + "img/house3b.1ff5707a.jpg";